import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { RestS } from "../../rest/rest-service";
import { history } from "../../Router/History";

export const fetchWorkspaceProgressData = createAsyncThunk(
  "wsProgress/fetch",
  async () => {
    const response: any = await RestS.draftReportByUser();
    return response;
  }
);

const wsProgress = createSlice({
  name: "wsProgress",
  initialState: {
    status: false,
    error: null,
    isRefresh: false,
    refreshMyWorkspace: false,
  },
  reducers: {
    dataReceived: (state, action) => {
      state.status = action.payload.status;
      let count = localStorage.getItem("refreshCount")
        ? Number(localStorage.getItem("refreshCount"))
        : 0;
      if (action.payload.status) {
        // localStorage.setItem("hasToRefresh", "true");
        localStorage.setItem("refreshCount", `${count + 1}`);
      } else {
        if (count > 0) {
          localStorage.setItem("refreshCount", `${count - 1}`);
        }
      }
    },
    createWs: (state, action) => {
      state.status = action.payload.status;
      // let count = localStorage.getItem("refreshCount") ? Number(localStorage.getItem("refreshCount")) : 0
      // localStorage.setItem("refreshCount", `${count - 1}`)
      // if (Boolean(hasToRedirect)) {
      //   setTimeout(() => {
      //     window.location.replace(`/reportDetails/${action.payload.reportId}`)
      //   }, 1000)
      // }
    },
    workspaceRefreshed: (state, action) => {
      state.status = action.payload.status;
      state.isRefresh = action.payload.isRefresh;
    },
    setRefreshMyWorkspace: (state, action) => {
      state.refreshMyWorkspace = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchWorkspaceProgressData.pending, (state) => {
        state.status = false;
      })
      .addCase(fetchWorkspaceProgressData.fulfilled, (state, action) => {
        if (action.payload.data?.length > 0) {
          state.status = true;
          let count = Number(localStorage.getItem("refreshCount"));
          if (count == 0 || count == undefined) {
            localStorage.setItem("refreshCount", action.payload.data?.length);
            localStorage.setItem("hasToRefresh", "true");
          }
          state.error = null;
        } else {
          state.status = false;
          state.error = null;
        }
      })
      .addCase(fetchWorkspaceProgressData.rejected, (state, action) => {
        state.status = false;
        state.error = action.error.message;
      });
  },
});

export const {
  dataReceived,
  workspaceRefreshed,
  createWs,
  setRefreshMyWorkspace,
} = wsProgress.actions;
export default wsProgress.reducer;
